import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addToCart } from '../Redux/features/Cart/CartSlice'
import { removeWishListItem } from '../Redux/features/WishList/WishlistSlice'
import { Link } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { formatSlug } from '../Utils/Helper'
import Swal from 'sweetalert2'
import { ConfigContext } from '../Context/ConfigContext'
import { convertCurrency, formatPrice } from '../Utils/GlobalFunction';

const WishList = () => {
    const dispatch = useDispatch()
    const wishList = useSelector(state => state.Wishlist)
    const { currency, currencyValue } = useContext(ConfigContext);
    
    const handleAddToCart = (product) => {
        dispatch(addToCart(product))
        toast.success(`${product.product_title} added to cart`, {
            position: "bottom-center",
        })
    }

    useEffect(() => {
        document.title = 'StoneSkill | WishList'
    }, [])

    return (
        <>
            <ToastContainer />
            <main className="main">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link to="/" rel="nofollow"><i className="fi-rs-home mr-5" />Home</Link>
                            <span /> Wishlist <span />
                        </div>
                    </div>
                </div>
                <div className="container mb-30 mt-50">
                    <div className="row">
                        <div className="col-xl-10 col-lg-12 m-auto">
                            <div className="mb-50">
                                <h1 className="heading-2 mb-10">Your Wishlist {wishList.length === 0 && (`Is Empty`)}</h1>
                                <h6 className="text-body">There are <span className="text-brand">{wishList?.length}</span> products in this list</h6>
                            </div>
                            <div className="table-responsive shopping-summery">
                                {
                                    wishList.length !== 0 ? (
                                        <table className="table table-wishlist">
                                            <thead>
                                                <tr className="main-heading">
                                                    <th scope="col" className="pl-30" colSpan={2}>Product</th>
                                                    <th scope="col">Price</th>
                                                    <th scope="col">Stock Status</th>
                                                    <th scope="col">Action</th>
                                                    <th scope="col">Remove</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    wishList.map((item) => (
                                                        <tr className="pt-30" key={item.product_id}>
                                                            <td className="image product-thumbnail pt-40 pl-30">
                                                                <img src={item.product_image_url} alt="#" />
                                                            </td>
                                                            <td className="product-des product-name">
                                                                <h6>
                                                                    <Link className="product-name mb-10" to={`/ProductDetails/${formatSlug(item.product_title)}=${item.product_id}`}>
                                                                        {item.product_title}
                                                                    </Link>
                                                                </h6>
                                                                <div className="product-rate-cover">
                                                                    <div className="product-rate d-inline-block">
                                                                        <div className="product-rating" style={{ width: '90%' }} />
                                                                    </div>
                                                                    <span className="font-small ml-5 text-muted"> (4.0)</span>
                                                                </div>
                                                            </td>
                                                            <td className="price" data-title="Price">
                                                                <h3 className="text-brand">{formatPrice(item.product_variant_sale_price, item.selected_currency)}</h3>
                                                            </td>
                                                            <td className="text-center detail-info" data-title="Stock">
                                                                <span
                                                                    className={item.product_stock_status === 0 ? 'stock-status out-stock mb-0' : 'stock-status in-stock mb-0'}
                                                                    style={item.product_stock_status > 0 ? { backgroundColor: 'rgba(183, 110, 121, 0.4)' } : {}}
                                                                >
                                                                    {item.product_stock_status > 0 ? "In Stock" : "Out stock"}
                                                                </span>
                                                            </td>
                                                            <td className="text-right" data-title="Cart">
                                                                <button
                                                                    className="btn btn-sm"
                                                                    onClick={() => item.product_stock_status !== 0 && handleAddToCart(item)}
                                                                    disabled={item.product_stock_status === 0}
                                                                >
                                                                    Add to cart
                                                                </button>
                                                            </td>
                                                            <td className="action text-center" data-title="Remove">
                                                                <span
                                                                    className="text-body"
                                                                    style={{ cursor: "pointer" }}
                                                                    onClick={() => dispatch(removeWishListItem(item.product_id))}
                                                                >
                                                                    <i className="fi-rs-trash" />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    ) : (
                                        <Link to='/' className="btn">
                                            <i className="fi-rs-arrow-left mr-10" />Continue Shopping
                                        </Link>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default WishList
